import { render, staticRenderFns } from "./PasswordComponent.vue?vue&type=template&id=0f68308e"
import script from "./PasswordComponent.vue?vue&type=script&lang=js"
export * from "./PasswordComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports